import clsx from "clsx";

import { rarityWord } from "../lib/format";

export type RarityBadgeProps = {
  /** 1..5 */
  rarity: number | null;
  className?: string;
  /** Hide the word and show only the pips. */
  pipsOnly?: boolean;
};

/**
 * Rarity as five letterpress pips, filled in ochre. Reads at a glance on a
 * checklist without needing to be a colour-coded badge.
 */
export function RarityBadge({ rarity, className, pipsOnly = false }: RarityBadgeProps) {
  const word = rarityWord(rarity);
  if (rarity === null || word === null) return null;

  const filled = Math.min(5, Math.max(1, Math.round(rarity)));
  const description = `Rarity ${filled} of 5 — ${word.toLowerCase()}`;

  return (
    <span className={clsx("inline-flex items-center gap-1.5", className)} title={description}>
      <span className="flex items-center gap-[2px]" aria-hidden="true">
        {[1, 2, 3, 4, 5].map((pip) => (
          <span
            key={pip}
            className={clsx(
              "block h-[7px] w-[3px] rounded-[0.5px]",
              pip <= filled ? "bg-ochre" : "bg-rule",
            )}
          />
        ))}
      </span>
      {pipsOnly ? null : <span className="field-label-tight text-ink-soft">{word}</span>}
      <span className="sr-only">{description}</span>
    </span>
  );
}
